export const prependZerosToNumber = (number: number, stringTotalLength: number) =>
  new Array(stringTotalLength - number.toString().length).fill('0').join('') + number.toString();
